import Util from './util'
const env = Util.getEnvironment()
console.log('loadVconsole env',env)
/**
 * @description 加载vconsole
 */

const loadVconsole = function(){
    if(env === 'test' || env === 'pre'){
        import(/* webpackChunkName: "dynamic4vconsole" */'vconsole').then(module => {
            const vconsole = new module.default()
        }).catch(error => {
            console.log('vconsole加载失败', error)
        })
    }
}

export default loadVconsole